import type { ConnectedFacility } from '../../../../../js/api/models/ConnectedFacility';
import { createGoogleMapsLink } from '../../../../../js/utils/address';

type ConnectionQuickDetailsProps = {
  connection: ConnectedFacility;
};

export function ConnectionQuickDetails({ connection }: ConnectionQuickDetailsProps) {
  const specialtyText =
    connection.opportunity?.specialty_display ||
    (connection.provider?.specialties || []).join(', ') ||
    '--';

  const facility = connection.facility;
  const mapLink = facility
    ? createGoogleMapsLink(
        facility.street_address || '',
        facility.city,
        facility.state,
        facility.zip_code
      )
    : null;

  const streetAddress = facility?.street_address || null;
  const cityStateZip =
    [facility?.city, facility?.state, facility?.zip_code].filter(Boolean).join(' ') || null;
  const hasAddress = streetAddress || cityStateZip;

  return (
    <div className="tw:bg-brand-green-0/10 tw:rounded-lg tw:p-4 tw:text-zinc-700 tw:leading-tight">
      <div className="tw:grid tw:grid-cols-2 tw:gap-x-4 tw:gap-y-3 tw:items-start">
        {/* Address */}
        <div className="tw:flex tw:items-start tw:gap-2">
          <i className="fa-solid fa-location-dot tw:text-brand-green-0 tw:shrink-0 tw:mt-0.5 fa-fw" />
          <div className="tw:flex tw:flex-col tw:flex-1 tw:min-w-0 tw:gap-0.5">
            {hasAddress ? (
              <>
                {streetAddress && <div className="tw:truncate">{streetAddress}</div>}
                {cityStateZip && <div className="tw:truncate">{cityStateZip}</div>}
              </>
            ) : (
              <div className="tw:truncate">--</div>
            )}
            {mapLink && (
              <a
                href={mapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="tw:text-sm tw:text-brand-green-0 tw:hover:text-brand-green-1 tw:hover:underline tw:dark:text-brand-green-1 tw:dark:hover:text-brand-green-0"
              >
                Map
              </a>
            )}
          </div>
        </div>

        {/* Specialty */}
        <div className="tw:flex tw:items-start tw:gap-2">
          <i className="fa-solid fa-stethoscope tw:text-brand-green-0 tw:shrink-0 tw:mt-0.5 fa-fw" />
          <span className="tw:truncate">{specialtyText}</span>
        </div>
      </div>
    </div>
  );
}
